import { string } from 'yup';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import { NumberingSeries } from 'shared-pages/shared/constants';

export const gqlGetQuery = gql`
  query getIdocs($limit: Int, $offset: Int, $order: String, $where: String) {
    getIdocs(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        idocPrefix
        identificationDocument
        dateCollected
        collectionPointName
        colpointAddressLine1
        collectionPointId
        collectorCompanyName
        wastereceptionpointCompanyName
        dateStorage
        vehPlateNumber
        driverFullName
        netWeight
        receptionNetWeight
        finalDestinationDate
        finalDestinationNetWeight
        finaldestinationCompanyName
        finaldestinationCompanyNoteDocNumber
      }
      recordCount
    }
  }
`;

export const gqlGetQueryExcel = gql`
  query getIdocs($limit: Int, $offset: Int, $order: String, $where: String) {
    getIdocs(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        idocMultiId
        isMulti
        isCancelled
        identificationDocument
        idocseriesId
        edocSeries {
          id
          name
        }
        idocPrefix
        idocNumber
        dateCollected
        wasteOriginTypeId
        wasteOriginType {
          id
          name
        }
        collectionPointId
        collectionpoint {
          id
          name
        }
        fromWastereceptionpointId
        fromWastereceptionpoint {
          id
          name
        }
        collectionPointName
        colpointAddressLine1
        colpointAddressLine2
        colpointAddressArea
        colpointAddressCity
        colpointPostalCode
        colpointVatNumber
        colpointTaxOffice
        colpointImaCode
        colpointPhoneNumber
        colpointEmail
        colpointCategoryId
        colpointCategory {
          name
        }
        regionId
        region {
          id
          name
        }
        materialId
        material {
          name
        }
        ekaCode
        unClass
        colpointContactPerson
        containersQty
        netWeight
        grossWeight
        tareWeight
        collectorId
        collector {
          name
        }
        collectorCompanyName
        collectorCompanyAddress
        collectorCompanyPhoneNumber
        collectorCompanyVat
        collectorCompanyTaxOffice
        collectorCompanyImaCode
        dateVehLoading
        vehicleId
        vehPlateNumber
        driverId
        driverFullName
        adrNumber
        altRouteDescription
        wasteDestinationTypeId
        wasteDestinationType {
          id
          name
        }
        dateStorage
        wastereceptionpointId
        wastereceptionpointCompanyName
        wastereceptionpointCompanyAddress
        wastereceptionpointCompanyPhoneNumber
        wastereceptionpointCompanyVat
        wastereceptionpointCompanyTaxOffice
        wastereceptionpointCompanyImaCode
        wastereceptionpointCompanyRegionId
        wastereceptionpointCompanyRegion {
          id
          name
        }
        wastereceptionpointCompanyEmail
        wastereceptionpointNoteDocNumber
        receptionPersonName
        receptionNetWeight
        finaldestinationpointId
        finaldestinationpoint {
          id
          name
          wasteDestinationTypeId
          wastedestinationtype {
            id
            name
          }
        }
        finaldestinationCompanyName
        finaldestinationCompanyAddress
        finaldestinationCompanyPhoneNumber
        finaldestinationCompanyVat
        finaldestinationCompanyTaxOffice
        finaldestinationCompanyImaCode
        finaldestinationCompanyEmail
        finaldestinationCompanyRegionId
        finaldestinationCompanyRegion {
          id
          name
        }
        finaldestinationCompanySubregionId
        finaldestinationCompanySubregion {
          id
          name
        }
        finaldestinationCompanyNoteDocNumber
        finalDestinationPersonName
        finalDestinationSignFileId
        finalDestinationDate
        finalDestinationNetWeight
        finaldestinationCompanyNoteDocNumber
        collectionId
        distance
        recordDate
        firstDate
        lastDate
        firstUser
        lastUser
        idocExtras {
          id
          idocId
          containertypeId
          containertype {
            id
            name
          }
          containersQty
          netWeight
          containerTareWeight
          materialId

          ekaCode
          unClass
        }
      }
      recordCount
    }
  }
`;
